import appleTrust from "@assets/app_store_app_of_the_day_2023_white.webp"
import googleTrust from "@assets/google_editors_choice_2023_white.webp"

export default function AwardBadges({
  className = "",
}: {
  className?: string
}) {
  return (
    <div
      className={`flex items-center justify-center gap-3 rounded-card bg-vm-ink px-4 py-3 dark:bg-vm-surface ${className}`}
    >
      <img
        alt="App Store App of the Day"
        className="h-10 w-auto"
        src={appleTrust}
      />
      <img
        alt="Google Play Editors' Choice"
        className="h-10 w-auto"
        src={googleTrust}
      />
    </div>
  )
}
